
export const GRAPH_INTERVAL = {
  day: 'day',
  week: 'week',
  month: 'month',
  year: 'year',
} as const;

export const CHART_TYPE = {
  area: 'area',
  line: 'line',
} as const;

export const METRIC_AGGREGATE = {
  items: 'items',
  sum: 'sum',
  max: 'max',
  avg: 'avg',
  wavg: 'wavg',
} as const;

export const BOX_TYPE = {
  FourGraphBox: 'FourGraphBox',
  RegroupedGraphBox: 'RegroupedGraphBox',
  SingleGraphBox: 'SingleGraphBox',
  SingleTimeRangeGraphBox: 'SingleTimeRangeGraphBox',
  MultiGraphBox: 'MultiGraphBox',
  PredictionGraphBox: 'PredictionGraphBox',
  HeatmapBox: 'HeatmapBox',
  StorageHeatmapBox: 'StorageHeatmapBox',
  TableBox: 'TableBox',
  TablePivotBox: 'TablePivotBox',
  TableGroupBox: 'TableGroupBox',
  TableHeaderGroupBox: 'TableHeaderGroupBox',
  TextBox: 'TextBox',
  HtmlTextBox: 'HtmlTextBox',
  HealthCheckBox: 'HealthCheckBox',
  DashboardBox: 'DashboardBox',
  SunburstBox: 'SunburstBox',
  TopBox: 'TopBox',
  CapacityTableBox: 'CapacityTableBox',
  TopologyBox: 'TopologyBox',
  TopologyRequestBox: 'TopologyRequestBox',
  PortHealthStatusBox: 'PortHealthStatusBox',
  EstimatorBox: 'EstimatorBox',
  EstimatorGraphBox: 'EstimatorGraphBox',
  OverviewBox: 'OverviewBox',
  CustomTopBox: 'CustomTopBox',
  RegroupButtonBox: 'RegroupButtonBox',
  MirrorBox: 'MirrorBox',
  ConfigurationChangesBox: 'ConfigurationChangesBox',
  SummaryBox: 'SummaryBox',
  SyncGraphBox: 'SyncGraphBox',
  LogRequestBox: 'LogRequestBox',
  EventRequestBox: 'EventRequestBox',
  HistoricalReportBox: 'HistoricalReportBox',
  LegendBox: 'LegendBox',
  SnapshotBox: 'SnapshotBox',
  StateTimelineBox: 'StateTimelineBox',
  HsTableBox: 'HsTableBox',
} as const;

export const TABLE_STYLE_CLASS = {
  heatmap: 'heatmap',
  center: 'center',
  bold: 'bold',
  thermometer: 'thermometer',
  healthStatus: 'healthStatus',
  gantt: 'gantt'
} as const;

export const TEXT_STYLE_CLASS = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  st: 'st'
} as const;

export const EXPORT_METHOD = {
  GET: 'GET',
  POST: 'POST',
} as const;

export const UNIT_PREFIX = {
  kilo: 'k',
  kibi: 'Ki',
  mega: 'M',
  mebi: 'Mi',
  giga: 'G',
  gibi: 'Gi',
  tera: 'T',
  tebi: 'Ti',
  peta: 'P',
  pebi: 'Pi',
  exa: 'E',
  exbi: 'Ei',
  zetta: 'Z',
  zebi: 'Zi',
  yotta: 'Y',
  yobi: 'Yi'
} as const;


export const MULTIPLIER = {
  base10: '1000',
  base2: '1024'
} as const;

export const TOPOLOGY_TYPE = {
  'switch-storage': 'switch-storage',
  'switch-switch': 'switch-switch',
  'switch-power': 'switch-power',
  'switch-tape': 'switch-tape',
  'fabric': 'fabric',
  'vmware-vm-topology': 'vmware-vm-topology',
  'vmware-esxi-topology': 'vmware-esxi-topology',
  'nutanix-topology': 'nutanix-topology',
  'power-sea': 'power-sea',
  'power-sriov': 'power-sriov',
  'linux-volume': 'linux-volume',
  'lan': 'lan',
  'tape-topology-v2': 'tape-topology-v2',
  'storage-vm-topology': 'storage-vm-topology',
  'fortigate': 'fortigate',
} as const;

// @deprecated
export const TOPOLOGY_ITEM_TYPE = {
  'switch': 'switch',
  'server': 'server',
  'lpar': 'lpar',
  'vios': 'vios',
  'cna': 'cna',
  'sriov': 'sriov',
  'sriovphysical': 'sriovphysical',
  'sriovlogical': 'sriovlogical',
  'vlan': 'vlan',
  'vswitch': 'vswitch',
  'sea_trunk': 'sea_trunk',
  'sea': 'sea',
  'sea_physical': 'sea_physical',
  'storage': 'storage',
  'host': 'host',
  'san': 'san',
  'virtual': 'virtual',
  'test': 'test',
  'datastore': 'datastore',
  'vm': 'vm',
  'volume': 'volume',
  'vhost': 'vhost',
  'fcport': 'fcport',
  'filesystem': 'filesystem',
  'volumegroup': 'volumegroup',
  'disk': 'disk',
  'pool': 'pool',
  'esxi': 'esxi',
  'tape': 'tape',
  'tape-library': 'tape-library',
  'tape-drive': 'tape-drive',
  'tape-port': 'tape-port',
  'vdisk': 'vdisk',
  'storage_pool': 'storage_pool',
  'vcenter': 'vcenter',
  'cluster': 'cluster',
  'item': 'item', // neutral item type for generic use
  'claim': 'claim',
  // Fortinet ecosystem topology nodes
  'firewall': 'firewall',
  'accesspoint': 'accesspoint',
  'vpn-endpoint': 'vpn-endpoint',
  'router': 'router',
  // Generic combined endpoint layer (used for FortiGate "star" topology where
  // FortiSwitch / FortiAP / Remote VPN are merged into a single chain layer
  // beneath the firewall to satisfy the adjacent-layers-only renderer).
  'endpoint': 'endpoint',
} as const;

export const ORIENTATION = {
  vertical: 'vertical',
  horizontal: 'horizontal'
} as const;
